import o from"./log.js";const r=async({signer:t,transactionInput:n})=>(o("transact","Starting transaction",t,n),t.signAndExecuteTransactionBlock(n));var c=r;export{c as default};
